'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const clearLodashAndUpper = (value) => {
  return value.replace(/_/, "").toUpperCase();
};
const clearHyphenAndUpper = (value) => {
  return value.replace(/-/, "").toUpperCase();
};
const toPascalCase = (value) => {
  value = value.replace(/(^\w|-\w)/g, clearHyphenAndUpper);
  value = value.replace(/(^\w|_\w)/g, clearLodashAndUpper);
  return value;
};

function forwardProps(props) {
  const pure = {};
  for (const prop in props) {
    if (props[prop] !== void 0) {
      pure[prop] = props[prop];
    }
  }
  return pure;
}

exports.forwardProps = forwardProps;
exports.toPascalCase = toPascalCase;
